var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIngestSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ingest"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.47851 10.2609C2.81417 10.0667 3.11731 9.88987 3.4216 9.71539C3.58537 9.62117 3.74797 9.52812 3.91522 9.44088C4.00232 9.39552 4.00348 9.34085 3.95935 9.26524C3.6144 8.68016 3.27991 8.08926 2.92218 7.51233C2.59001 6.97843 2.06853 6.76673 1.45877 6.75161C1.01858 6.73997 0.578397 6.74812 0.138211 6.74928C0.0592335 6.74928 0 6.74928 0 6.63762C0.00348432 6.11767 0 5.59657 0 5.07663C0 5.05802 0.00813009 5.04057 0.0150987 5.00567C0.256678 5.00567 0.498258 4.99055 0.737515 5.00916C1.27642 5.04987 1.81533 5.09175 2.35076 5.16154C3.1928 5.27088 3.7921 5.77105 4.24158 6.44685C4.63879 7.04356 4.99071 7.66936 5.35772 8.28584C5.50058 8.52662 5.49245 8.53011 5.73403 8.39053C6.14286 8.15557 6.55401 7.92177 7 7.66703C6.79907 9.12682 6.60163 10.5529 6.40302 11.9999C5.08014 11.4136 3.79326 10.8425 2.47967 10.2609H2.47851Z",
    fill: "url(#paint0_linear_397_7412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.8797 10.267C13.7545 10.8485 12.658 11.416 11.5298 11.9999C11.3539 10.556 11.1789 9.12377 11 7.65309C11.2594 7.83139 11.4881 7.99104 11.7187 8.1472C11.8728 8.25092 12.0288 8.34997 12.1839 8.45252C12.2634 8.5038 12.3111 8.51196 12.3648 8.38959C12.6809 7.6729 13.0079 6.96319 13.4364 6.32574C13.6849 5.95516 13.9503 5.58574 14.33 5.40627C14.6441 5.25711 14.9821 5.14523 15.3181 5.09978C15.83 5.02986 16.3499 5.03336 16.8658 5.00073C16.9682 4.99373 17.001 5.0287 17 5.15222C16.993 5.63468 16.993 6.11831 16.997 6.60077C16.997 6.7173 16.9602 6.7511 16.8658 6.74993C16.4811 6.74644 16.0954 6.74644 15.7107 6.7511C15.4523 6.75459 15.2018 6.80703 14.9622 6.9259C14.7077 7.05176 14.5517 7.29998 14.4165 7.55869C14.1282 8.10991 13.8568 8.67278 13.5755 9.22982C13.5318 9.31605 13.5447 9.36849 13.6183 9.41627C13.995 9.66799 14.3708 9.92204 14.7465 10.1749C14.7833 10.1994 14.8201 10.225 14.8807 10.267H14.8797Z",
    fill: "url(#paint1_linear_397_7412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9973 4.00058C10.8177 5.01253 9.66622 5.99947 8.50134 6.99988C7.3311 5.99466 6.18098 5.00676 5 3.99288C5.09394 3.99288 5.15031 3.99288 5.20801 3.99288C5.89513 3.99288 6.58359 3.99288 7.27071 3.99288C7.50153 3.99288 7.50556 3.98999 7.50556 3.8255C7.50556 2.60193 7.50556 1.37835 7.50556 0.154772C7.50556 0.0502422 7.57848 -0.00138133 7.72431 -9.87507e-05C8.25575 0.00374898 8.78585 0.0124062 9.31729 0.0104824C9.47028 0.0104824 9.50249 0.0499217 9.50249 0.150924C9.49847 1.34661 9.49847 2.54229 9.49847 3.73797C9.49847 3.77741 9.50249 3.81781 9.49847 3.85725C9.49041 3.95729 9.5441 3.99673 9.6944 3.99577C10.399 3.99096 11.1035 3.99384 11.8081 3.99384C11.8564 3.99384 11.9047 3.99769 12 4.00058H11.9973Z",
    fill: "url(#paint2_linear_397_7412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2 17.3939C1.45 17.3939 0.979333 17.1983 0.588 16.8069C0.196 16.4149 0 15.9439 0 15.3939V13.3939C0 13.1106 0.0956668 12.8729 0.287 12.6809C0.479 12.4896 0.716667 12.3939 1 12.3939C1.28333 12.3939 1.521 12.4896 1.713 12.6809C1.90433 12.8729 2 13.1106 2 13.3939V15.3939H14V13.3939C14 13.1106 14.096 12.8729 14.288 12.6809C14.4793 12.4896 14.7167 12.3939 15 12.3939C15.2833 12.3939 15.5207 12.4896 15.712 12.6809C15.904 12.8729 16 13.1106 16 13.3939V15.3939C16 15.9439 15.8043 16.4149 15.413 16.8069C15.021 17.1983 14.55 17.3939 14 17.3939H2Z",
    fill: "url(#paint3_linear_397_7412)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_397_7412",
    x1: 0,
    y1: 8.49988,
    x2: 7,
    y2: 8.49988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_397_7412",
    x1: 11,
    y1: 8.49988,
    x2: 17,
    y2: 8.49988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_397_7412",
    x1: 5,
    y1: 3.49988,
    x2: 12,
    y2: 3.49988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_397_7412",
    x1: 0,
    y1: 14.8939,
    x2: 16,
    y2: 14.8939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIngestSelectedIcon);
export default __webpack_public_path__ + "static/media/DocIngestSelectedIcon.7b2b9c810a020969c89a3b3dd66d8931.svg";
export { ForwardRef as ReactComponent };